import {Grid} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import styles from 'assets/jss/Login/loginPage';
import {registerSteps} from './SignIn';

const useStyles = makeStyles(styles);

const Header = ({currentStep, phone}) => {
  const classes = useStyles();

  let bodyContent;

  if (currentStep === registerSteps.sendloginCode) {
    bodyContent = (
      <p className={classes.text}>
        برای ورود یا ثبت نام
        <br />
        <span className={classes.boldText}>شماره موبایل</span> خود را وارد کنید:
      </p>
    );
  }

  if (currentStep === registerSteps.login) {
    bodyContent = (
      <p className={classes.text}>
        <span className={classes.boldText}>کد چهار رقمی </span>
        ارسال شده به شماره <br />
        <span style={{color: '#753CBE', letterSpacing: '0.5px'}}>{phone} </span>
        را وارد کنید:
      </p>
    );
  }

  if (currentStep === registerSteps.signup) {
    bodyContent = (
      <p className={classes.text} style={{fontSize: '17.5px'}}>
        این شماره موبایل ثبت نشده است
        <br />
        برای ورود لطفا <span className={classes.boldText}>ثبت نام</span> خود را
        کامل کنید:
      </p>
    );
  }

  return (
    <Grid item xs={12} mb='34px'>
      {bodyContent}
    </Grid>
  );
};

export default Header;
